/* eslint-disable max-lines-per-function */
import * as React from "react";
import { Grid, TextField } from "@material-ui/core";
import { RadioBasic } from "components/common/form";
import { Select } from "components/haven-design/form/select";
import ErrorMessage from "components/error-message";
import styles from "./batchActions.module.css";

export interface LogCallStateValues {
  reason: string;
  outcome: string;
  note: string;
}

const outcomeOptions = [
  "No answer",
  "Not in service",
  "Left Voicemail",
  "Spoke to Applicant",
  "Spoke to Applicant's Representative",
  "Left message with someone else",
  "Other",
];

const reasonOptions = [
  "Calling about a vacancy",
  "Calling to schedule interview",
  "Calling to update information",
  "Other",
];

interface Props {
  phones: {
    type: string;
    number: string;
  }[];
  onChange: (input: LogCallStateValues) => void;
  isShowing: boolean;
  errorMsg?: string;
}

const LogCallForm: React.FC<Props> = (props) => {
  const {
    phones,
    onChange,
    isShowing,
    errorMsg,
  } = props;

  const [outcome, setOutcome] = React.useState("");
  const [reason, setReason] = React.useState("");
  const [note, setNote] = React.useState("");


  return (
    <div className={isShowing ? "" : styles.hideView}>
      <div className={styles.actionViewLabel}>Log a Call</div>

      <form onSubmit={(e) => e.preventDefault()}>
        <div className={styles.logCallPhones}> {
          phones.map((phone, i) => (
            <RadioBasic
              label={`${phone.type}: ${phone.number}`}
              name={phone.type}
              value={phone.number}
              defaultChecked={i === 0}
              key={`${phone.type}: ${phone.number}`}
            />
          ))
        }
        </div>

        <ErrorMessage errorMsg={errorMsg}/>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Select
              id="log-call-outcome"
              value={outcome}
              onChange={(e) => {
                setOutcome(e.target.value);
                onChange({ reason, outcome: e.target.value, note });
              }}
              className={styles.marginRight}>
              <option disabled value="">
              Select Outcome *
              </option>
              {outcomeOptions.map((value, i) => (
                <option key={i} value={value}>
                  {value}
                </option>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Select
              id="log-call-reason"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                onChange({ reason: e.target.value, outcome, note });
              }}>
              <option disabled value="">Select Reason</option>
              {reasonOptions.map((value, i) => (
                <option key={i} value={value}>
                  {value}
                </option>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Call Notes"
              placeholder="Recap your call..."
              multiline
              fullWidth
              variant="outlined"
              value={note}
              onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                setNote(e.target.value);
                onChange({ reason, outcome, note: e.target.value });
              }}
            />
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default LogCallForm;
